import { render, staticRenderFns } from "./oneWeekUnifiedMeals.vue?vue&type=template&id=520f22d9&scoped=true&"
import script from "./oneWeekUnifiedMeals.vue?vue&type=script&lang=js&"
export * from "./oneWeekUnifiedMeals.vue?vue&type=script&lang=js&"
import style0 from "./oneWeekUnifiedMeals.vue?vue&type=style&index=0&id=520f22d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f22d9",
  null
  
)

export default component.exports